export default __webpack_public_path__ + "static/media/level_inactive.1d9bfacc.svg";